<template>
    <div>
        <h1>Alkane</h1>
        <p>
            Alkane sind gesättigte, acyclische Kohlenwasserstoffe. Das heißt,
            sie bestehen aus ausschließlich C und H Atomen, welche nur
            Einfachbindungen und keine Kohlenstoffringe besitzen. Für alle gilt
            eine allgemeine Strukturformel von C<sub>n</sub>H<sub>2n+2</sub>.
            Das Alkan kann aus unverzweigten Verbindungen, n-Alkane genannt,
            oder aus verzweigten Verbindungen, Isoalkane oder i-Alkane genannt,
            bestehen. Die Einfachbindungen sind frei drehbar und bestehen aus
            Sigma-Bindungen, d.h. einer Überlappung von sp3-Hybrid-Orbitalen.
        </p>
        <img
            src="@/assets/img/stoffe/alkane/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Alkane"
            title="Allgemeine Struktur der Alkane"
            width="128px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Homologe Reihe"></chapter-heading>
        <div class="row">
            <table class="column left">
                <tr>
                    <th>1.</th>
                    <td>CH<sub>4</sub></td>
                    <td>Methan</td>
                </tr>
                <tr>
                    <th>2.</th>
                    <td>C<sub>2</sub>H<sub>6</sub></td>
                    <td>Ethan</td>
                </tr>
                <tr>
                    <th>3.</th>
                    <td>C<sub>3</sub>H<sub>8</sub></td>
                    <td>Propan</td>
                </tr>
                <tr>
                    <th>4.</th>
                    <td>C<sub>4</sub>H<sub>10</sub></td>
                    <td>Butan</td>
                </tr>
                <tr>
                    <th>5.</th>
                    <td>C<sub>5</sub>H<sub>12</sub></td>
                    <td>Pentan</td>
                </tr>
                <tr>
                    <th>6.</th>
                    <td>C<sub>6</sub>H<sub>14</sub></td>
                    <td>Hexan</td>
                </tr>
                <tr>
                    <th>7.</th>
                    <td>C<sub>7</sub>H<sub>16</sub></td>
                    <td>Heptan</td>
                </tr>
                <tr>
                    <th>8.</th>
                    <td>C<sub>8</sub>H<sub>18</sub></td>
                    <td>Octan</td>
                </tr>
                <tr>
                    <th>9.</th>
                    <td>C<sub>9</sub>H<sub>20</sub></td>
                    <td>Nonan</td>
                </tr>
                <tr>
                    <th>10.</th>
                    <td>C<sub>10</sub>H<sub>22</sub></td>
                    <td>Decan</td>
                </tr>
                <tr>
                    <td>...</td>
                </tr>
            </table>

            <table class="column left">
                <tr>
                    <th>Allgemein:</th>
                    <td>C<sub>n</sub>H<sub>2n+2</sub></td>
                </tr>
            </table>
        </div>
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen"></chapter-heading>
        <ul>
            <li>
                Halogenierung unter Lichteinfluss (<router-link
                    to="/reaktionen/radikalische-substitution"
                    >Radikalische Substitution </router-link
                >) =>
                <router-link to="halogenalkane">Halogenalkane</router-link>
            </li>
            <li>
                Dehydrierung => <router-link href="alkene">Alkene</router-link>
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading
            title="Beispiel einer Strukturformel"
        ></chapter-heading>
        <img
            src="@/assets/img/stoffe/alkane/pentan.png"
            alt="Beispielhafte Strukturformel: Pentan"
            title="Beispielhafte Strukturformel: Pentan"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Schmelz- und Siedepunkte"></chapter-heading>
        <img
            src="@/assets/img/stoffe/alkane/schmelz-sidepunkte.png"
            width="500px"
            height="auto"
            alt="Die Schmelz- bzw. Siedetemperaturen der Alkane bis 14 C-Atome graphisch dargestellt"
            title="Die Schmelz- bzw. Siedetemperaturen der Alkane bis 14 C-Atome graphisch dargestellt"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>bestehen nur aus C-Atomen und H-Atomen</li>
                        <li>besitzen ausschließlich Einfachbindungen</li>
                        <li>gesättigte, acyclische Kohlenwasserstoffe</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Summenformel</th>
                <td>C<sub>n</sub>H<sub>2n+2</sub></td>
            </tr>
            <tr>
                <th>Eigenschaften</th>
                <td>
                    <ul>
                        <li>gesättigt</li>
                        <li>hydrophob</li>
                        <li>lipophil</li>
                        <li>brennbar</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>Einfachbindungen (Sigma-Bindungen)</td>
            </tr>
        </table>
    </div>
</template>

<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
